import {
  CButton,
  CCol,
  CFormLabel,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import React, { useState } from "react";
import ReactSelect from "react-select";

const RemoveOrderModal = ({
  selectedOderToRemove,
  setSelectedOrderToRemove,
  orderRemovePriority,
  setOrderRemovePriority,
  onConfirm,
}) => {
  return (
    <CModal
      backdrop="static"
      visible={!!selectedOderToRemove}
      onClose={() => {
        setSelectedOrderToRemove(null);
      }}
    >
      <CModalHeader onClose={() => setSelectedOrderToRemove(null)}>
        <CModalTitle>Remove Order</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="mb-2">
          For now you can't remove an order directly from the trip. You can only
          change the order priority to Emergency.
        </div>
        <CRow className="mb-3">
          <CFormLabel
            htmlFor="orderNumber"
            className="col-sm-3 col-form-label"
            style={{ width: "40%" }}
          >
            Priority:
          </CFormLabel>
          <CCol sm={12} style={{ width: "60%" }}>
            <ReactSelect
              value={orderRemovePriority}
              onChange={(selectedOption) =>
                setOrderRemovePriority(selectedOption)
              }
              options={[
                {
                  label: "normal",
                  value: "normal",
                },
                {
                  label: "emergency",
                  value: "emergency",
                },
              ]}
              isClearable={false}
              className="text-capitalize"
            />
          </CCol>
        </CRow>
        <div className="justify-content-center d-flex gap-3">
          <CButton
            type="button"
            color="danger"
            onClick={() => {
              setSelectedOrderToRemove(null);
              setOrderRemovePriority(null);
            }}
            className="text-white"
          >
            Cancel
          </CButton>
          <CButton
            type="button"
            color="primary"
            onClick={(e) => onConfirm(e, selectedOderToRemove)}
          >
            Confirm
          </CButton>
        </div>
      </CModalBody>
    </CModal>
  );
};

export default RemoveOrderModal;
